import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Reset scroll on every route change. React Router preserves scrollY by
// default, so clicking a footer link while scrolled to the bottom of the
// current page leaves the next page rendered at scrollY=bottom too.
// Mounted in App.js's Layout, before <Outlet />.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
